import { registerComponent } from '@site/js/utils/react-register'
import { FC } from 'react'

export async function enableMocking() {
  if (!window.enableMSWOnDev || process.env.WEBPACK_SERVE !== 'true') {
    return
  }

  const { worker } = await require('@mocks/browser')
  return worker.start()
}

export async function registerReactComponent(componentName: string, component: FC) {
  enableMocking()
    .then(() => {
      registerComponent(componentName, component)
    })
    .catch(e => console.error(e))
}
